import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  Output,
  Renderer2
} from '@angular/core';
import { Search, SearchItem, Tabs } from '@com-delta-omnichannel/mach-core-js';
import { CloseHeaderButtonComponent } from '../close-header-button/close-header-button.component';
import { AirportDropdownModalExtendedComponent } from './airport-dropdown-modal-extended.component';
import {
  AirportDropDown,
  AirportDropDownList
} from './models/airport-dropdown.interfaces';
@Component({
  selector: 'idp-airport-dropdown-modal',
  imports: [CommonModule, CloseHeaderButtonComponent, A11yModule],
  templateUrl: './airport-dropdown-modal.component.html',
  styleUrls: ['./airport-dropdown-modal.component.scss'],
  standalone: true
})
export class AirportDropdownModalComponent
  extends AirportDropdownModalExtendedComponent
  implements AfterViewInit, OnDestroy
{
  @Input() content = {} as AirportDropDown;
  @Input() selectedValue?: AirportDropDownList;
  @Output() closeButton = new EventEmitter<void>();
  @Output() airportSelected = new EventEmitter<AirportDropDownList>();
  @Output() searchValueEmit = new EventEmitter<string>();
  @Input() searchErrorMessage = '';
  renderer2 = inject(Renderer2);
  tabsSmallFixedInstance!: Tabs;
  searchTerm = '';
  selectedIndexPanel = 0;

  ngAfterViewInit(): void {
    this.initializeComponents();
    this.renderer2.setStyle(document.body, 'overflow', 'hidden');
    setTimeout(() =>
      this.selectedValue?.name
        ? this.searchInstance.setSearchTerm(this.selectedValue?.name)
        : this.searchInstance.clearSearch()
    );
  }

  setItem(content: SearchItem[], id: string): void {
    if (content.length > 0 && this.searchInstance) {
      this.searchInstance.setItems(content);
      if (id !== 'vacation-search-transparent') {
        this.searchInstance.show();
      }
    }
  }

  initializeComponents(): void {
    if (this.content.tabOptions) {
      this.tabsSmallFixedInstance = new Tabs(this.content.tabOptions);
      this.onTabClick();
    }
    this.searchInstance = new Search(this.content.airportList);
    this.inputValue();
    this.selectAirport();
    this.searchInstance.focus();
    document.addEventListener(
      'click',
      (event) => {
        this.clearSearch(event);
      },
      true
    );
  }

  onTabClick(): void {
    this.tabsSmallFixedInstance?.onTabChange((index) => {
      this.selectedIndexPanel = index;
    });
  }

  inputValue(): void {
    this.searchInstance.onSearch((term) => {
      if (term.length < 3) this.searchInstance.hide();

      this.searchValueEmit.emit(term.toUpperCase());
    });
  }

  closeModal(): void {
    this.closeButton.emit();
  }

  selectAirport(): void {
    this.searchInstance.onSelect((option) => {
      const selected: AirportDropDownList = {
        code: option.code ?? '',
        name: option.label
      };
      this.airportSelected.emit(selected);
      this.closeModal();
    });
  }

  ngOnDestroy(): void {
    if (this.searchInstance) {
      this.renderer2.setStyle(document.body, 'overflow', 'auto');
      this.searchInstance.destroy();
    }
  }
}
